'use client';

import { ChangeEvent } from "react";

const InputSearcBox = ({
  placeholder,
  value,
  onChange,
  onKeyDown,
  onBlur,
  className = '',
  inputTestId,
}: {
  className?: string;
  placeholder: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: any) => void;
  onBlur?: () => void;
  inputTestId?: string;
}) => {
  return (
    <div className={`relative w-full md:w-[300px] ${className}`}>
      <div className="absolute top-1/2 -translate-y-1/2 left-2 h-6 w-6 text-gray-500">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <input
        data-testid={inputTestId}
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        className="w-full bg-[#282828] text-sm rounded-[20px] pl-12 pr-16 py-2 border-gray-300 text-gray-300 focus:outline-none"
        placeholder={placeholder}
      />
    </div>
  );
};

export default InputSearcBox;